const env = import.meta.env;

const Configuration = {
  API_BASE_URL: env.VITE_API_BASE_URL,
  INTERCOM_APP_ID: env.VITE_INTERCOM_APP_ID,
  AMPLITUDE_API_KEY: env.VITE_AMPLITUDE_API_KEY || "",
  AMPLITUDE_SERVER_ZONE: env.VITE_AMPLITUDE_SERVER_ZONE || "US",
  ADMIN_CONSOLE_SESSIONS_LINK: env.VITE_ADMIN_CONSOLE_SESSIONS_LINK,
  NEW_TAG_REQUEST_RECEIVER: env.VITE_NEW_TAG_EMAIL_REQUEST_RECEIVER,
  ENABLE_REMOTE_LOGGING: env.VITE_ENABLE_REMOTE_LOGGING === "true",
  COOKIEBOT_CBID: env.VITE_COOKIEBOT_CBID,
  CONTENT_ADMINS: env.VITE_CONTENT_ADMINS ? JSON.parse(env.VITE_CONTENT_ADMINS) : [],
  STRIPE_API_KEY: env.VITE_STRIPE_API_KEY || "",
  SHOW_INTERCOM: env.VITE_SHOW_INTERCOM === "true",
  ENABLE_CONSOLE_LOGGING: env.VITE_ENABLE_CONSOLE_LOGGING === "true",
};

export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyDv5xfPmupzkHIAbT2liArWmfu-EQmNwT8",
  authDomain: "talaera-2c4a2.firebaseapp.com",
  databaseURL: "https://talaera-2c4a2.firebaseio.com",
  projectId: "talaera-2c4a2",
  storageBucket: "talaera-2c4a2.appspot.com",
  messagingSenderId: "88048258746",
  appId: "1:88048258746:web:f76bd25588bb22f7a37c83",
};

export function isProdOrigin() {
  return window.location.origin.indexOf("app.talaera.com") > -1;
}

export default Configuration;
